export default "__VITE_ASSET__tBVmBvN6__"